// The console in the browser (spec/13, spec/14): one app, served as static files from the CDN (spec/03
// §2), talking to the api through the generated client. Which console — the venue and organisation
// console or the HQ console — is the build's choice (`clavian:surface`, vite/surface.ts).

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { surface } from 'clavian:surface';

// The stylesheet first, so a screen's own stylesheet (imported by its module) comes after it and wins.
import './styles.css';

import { createConsoleApi } from './api/client';
import { ConsoleApp } from './app';
import { paintConsoleTheme, readConsoleTheme } from './shell/theme';

// The member's theme on <html> before the first render, so a light-theme member never sees the dark ground first.
paintConsoleTheme(readConsoleTheme());

const root = document.getElementById('root');
if (!root) throw new Error('The console needs a #root element.');

createRoot(root).render(
  <StrictMode>
    <ConsoleApp api={surface.createApi?.() ?? createConsoleApi()} surface={surface} />
  </StrictMode>,
);
